export default "__VITE_ASSET__BQA8da7W__"